module.exports = __webpack_public_path__ + "static/media/picture1.280d5b41.png";